import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function PersonSelect({ label, value, onChange, people, testId, allowNone = false, placeholder = "Choose a person" }) {
  return (
    <div>
      <Label>{label}</Label>
      <Select value={value || (allowNone ? "none" : undefined)} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
        <SelectTrigger className="mt-1" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>
          {allowNone && <SelectItem value="none">No one</SelectItem>}
          {people.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}{p.title ? ` · ${p.title}` : ""}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

// Independent review: the reviewer (and optional alternate) must never be the person doing the work.
export function ReviewFields({ f, set, people }) {
  const others = people.filter((p) => p.id !== f.owner_id);
  return (
    <div className="rounded-xl border border-[#E4E8EF] p-3.5" data-testid="review-fields">
      <label className="flex items-center justify-between gap-3 text-sm">
        <span>
          <span className="font-medium text-[#0B1729]">Needs independent review</span>
          <span className="block text-xs text-[#1E2D44]/50">Someone other than the owner approves it before it counts as done.</span>
        </span>
        <Switch checked={f.requires_review} onCheckedChange={(v) => set("requires_review", v)} data-testid="requires-review-switch" />
      </label>
      {f.requires_review && (
        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          <PersonSelect label="Reviewer" value={f.reviewer_id} onChange={(v) => set("reviewer_id", v)} people={others} testId="reviewer-select" />
          <PersonSelect label="Alternate approver" value={f.alternate_reviewer_id} onChange={(v) => set("alternate_reviewer_id", v)} people={others} testId="alt-reviewer-select" allowNone />
        </div>
      )}
    </div>
  );
}

export const reviewPayload = (f) => ({
  requires_review: f.requires_review,
  reviewer_id: f.requires_review ? f.reviewer_id || null : null,
  alternate_reviewer_id: f.requires_review ? f.alternate_reviewer_id || null : null,
});
